<template>
    <span>
        <b-form-checkbox :id="templateArgs.id" class="custom-grid-checkbox" @change="onChange" v-show="condition"></b-form-checkbox>
    </span>
</template>

<script>
export default {
  data () {
    return {
      templateArgs: {}
    }
  },
  computed: {
    condition () {
      if (typeof this.templateArgs.data.condition === 'function') {
        return this.templateArgs.data.condition(this.templateArgs)
      }

      return true
    }
  },
  methods: {
    onChange (e) {
      this.templateArgs.data.change(e, this.templateArgs)
    }
  }
}
</script>
